//Url For backend
let baseUrl = "https://hotelbookingbackend.herokuapp.com";
//let baseUrl = "http://localhost:5000";
export default baseUrl;
